import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@narrative-studio/ui/tokens.css';
import { Site } from './Site.tsx';

createRoot(document.getElementById('root')!).render(<StrictMode><Site /></StrictMode>);
